import { Fragment, useEffect, useState } from "react";


//Axios and API Url
import { API_URL, API_BACKEND } from "../../actions/types";
import { GOOGLE_API_KEY } from "../../actions/types";

import axios from "axios";
// Socket Io connection
import io from "socket.io-client";

//Redux
import { connect } from "react-redux";
import PropTypes from "prop-types";

//React Router Dom
import { Link, useParams, useHistory } from "react-router-dom";

//Redux Actions

//Popups
//Popup
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

import {
  deleteSensoryData,
  getSpecificDay,
  getSensoryDataByDate,
  getSpecificTruck,
} from "../../actions/truck";

//Components
import InfoCard from "../component/InfoCard";
import SensorTable from "../component/SensorTable";
import SensorTableReview from "../component/SensorTableReview";
import SensorGraph from "../component/SensorGraph";
import SensorMultilineGraph from "../component/SensorMultilineGraph";
import SensorCardForGyro from "../component/SensorCardForGyro";
import SensorGraphArea from "../component/SensorGraphArea";
import Speed from "../component/Speed";
import SensorCard from "../component/SensorCard";
import GoogleMap from "../component/GoogleMap";
import Geocode from "react-geocode";
import Spinner from "../../utils/Spinner";
import SensorMultilineGraphAreaHistory from "../component/SensorMultilineGraphAreaHistory";
import DocumentMeta from "react-document-meta";

//CSS
import "../css/Dashboard.css";
import BusImg from "../assets/busMarker.png";
import JeepneyImg from "../assets/jeepneyMarker.png";


//ANTD ICONS
import {Row,Col,Card,Button,Tag,PageHeader,Radio,Tabs,Divider,notification,Alert,Popconfirm,Tooltip,Segmented,Popover,Badge,DatePicker, } from "antd";
import { TextLoop } from "react-text-loop-next";
import Icon, {ExperimentOutlined,RiseOutlined,ExpandAltOutlined, ArrowLeftOutlined} from "@ant-design/icons";

//REACT ICONS
import { AiOutlineSound } from "react-icons/ai";
import { RiTempColdLine } from "react-icons/ri";
import { MdRotateRight } from "react-icons/md";
import { GiVibratingBall } from "react-icons/gi";


import ACCELEROMETER from "../assets/accelerometer.png";
import GYROSCOPE from "../assets/gyroscopesensor.png";

//META
const meta = {
  title: "PASADA",
  description: "Monitoring dashboard",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "dashboard,pasada, pasadaph",
    },
  },
};

const ThermometerSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-thermometer-low" viewBox="0 0 16 16">
  <path d="M9.5 12.5a1.5 1.5 0 1 1-2-1.415V9.5a.5.5 0 0 1 1 0v1.585a1.5 1.5 0 0 1 1 1.415z"/>
  <path d="M5.5 2.5a2.5 2.5 0 0 1 5 0v7.55a3.5 3.5 0 1 1-5 0V2.5zM8 1a1.5 1.5 0 0 0-1.5 1.5v7.987l-.167.15a2.5 2.5 0 1 0 3.333 0l-.166-.15V2.5A1.5 1.5 0 0 0 8 1z"/>
</svg>
);
const ThermometerIcon = (props) => <Icon component={ThermometerSvg} {...props} />;

const SoundSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-volume-up" viewBox="0 0 16 16">
  <path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z"/>
  <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z"/>
  <path d="M10.025 8a4.486 4.486 0 0 1-1.318 3.182L8 10.475A3.489 3.489 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.486 4.486 0 0 1 10.025 8zM7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12V4zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11z"/>
</svg>
);
const SoundIcon = (props) => <Icon component={SoundSvg} {...props} />;

const UltrasonicSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100"><path fill="currentColor" d="M45.697 45.697a6.083 6.083 0 0 0-.002 8.603a6.082 6.082 0 0 0 8.606.001a6.08 6.08 0 0 0 0-8.607a6.08 6.08 0 0 0-8.604.003zm30.852 33.468c15.972-16.109 15.934-42.207-.122-58.263c-.023-.023-.05-.037-.073-.059l.006-.006l-1.696-1.698l-.02.02a2.38 2.38 0 0 0-3.136.141l-.003-.003l-.026.026l-.008.007l-.006.008l-2.773 2.772l-.002.002a.002.002 0 0 1-.002.002l-.2.2l.02.02a2.376 2.376 0 0 0 .01 2.951l-.019.019l.19.19v.001h.001L70.196 27l.027-.027c.022.023.037.05.06.073C82.95 39.714 82.99 60.3 70.405 73.02l-.017-.017l-1.504 1.504l-.003.002l-.002.003l-.188.188l.019.019a2.38 2.38 0 0 0 .141 3.136l-.003.003l.031.031l.002.003l.003.002l1.396 1.396l.002.003l.003.002l1.376 1.376l.002.003l.003.002l.198.198l.02-.02a2.377 2.377 0 0 0 2.952-.009l.019.019l1.567-1.568a.018.018 0 0 1 .005-.004l.018-.019l.107-.107l-.003-.001z"/><path fill="currentColor" d="M64.923 67.54c9.561-9.699 9.523-25.365-.123-35.01c-.023-.023-.05-.037-.073-.06l.007-.007l-1.697-1.698l-.02.02a2.382 2.382 0 0 0-3.136.141l-.003-.003l-.029.029l-.005.004l-.004.005l-2.774 2.774l-.004.003l-.003.004l-.198.198l.02.02a2.376 2.376 0 0 0 .009 2.951l-.019.019l.189.189l.002.002l.002.002l1.504 1.505l.027-.027c.022.023.037.05.06.073c6.258 6.257 6.293 16.407.119 22.717l-.013-.013l-1.505 1.505l-.002.001l-.001.002l-.189.189l.019.019a2.38 2.38 0 0 0 .141 3.135l-.004.004l2.816 2.815l.201.201l.02-.02a2.378 2.378 0 0 0 2.951-.009l.02.02l1.572-1.572l.125-.125l-.002-.003z"/><g fill="currentColor"><path d="M54.305 45.7a6.083 6.083 0 0 0-8.606-.001a6.08 6.08 0 0 0 0 8.605a6.08 6.08 0 0 0 8.605-.001a6.084 6.084 0 0 0 .001-8.603z"/><path d="m43.109 63.089l.019-.019l-.188-.188l-.003-.004l-.003-.003l-1.503-1.504l-.027.027c-.022-.023-.037-.05-.059-.072c-6.258-6.258-6.293-16.408-.119-22.718l.013.013l1.697-1.696l-.02-.02a2.38 2.38 0 0 0-.141-3.135l.004-.004l-3.018-3.017l-.02.02a2.376 2.376 0 0 0-2.951.009l-.019-.019l-.191.191l-1.381 1.381l-.125.125l.003.003c-9.562 9.699-9.523 25.365.123 35.011c.022.022.049.037.072.059l-.006.006l1.697 1.698l.02-.02a2.382 2.382 0 0 0 3.135-.141l.003.003l.029-.029l.005-.004l.004-.005l2.775-2.775l.003-.002l.002-.002l.199-.199l-.02-.02a2.374 2.374 0 0 0-.009-2.95z"/><path d="m31.483 74.715l.019-.019l-.19-.19l-.001-.001l-.001-.001l-1.506-1.505l-.027.027c-.022-.023-.037-.05-.059-.073C17.05 60.284 17.012 39.7 29.597 26.98l.016.016l1.504-1.504l.003-.002l.002-.003l.188-.188l-.019-.019a2.38 2.38 0 0 0-.141-3.136l.004-.004l-1.434-1.434l-.001-.001l-.001-.001l-1.581-1.581l-.02.021a2.376 2.376 0 0 0-2.951.009l-.02-.02l-1.696 1.697l.003.003c-15.974 16.11-15.936 42.209.121 58.265c.023.023.05.037.073.059l-.007.007l1.697 1.698l.02-.02a2.382 2.382 0 0 0 3.136-.142l.003.003l.033-.033l2.778-2.779l.005-.004l.004-.005l.196-.196l-.02-.02a2.376 2.376 0 0 0-.009-2.951z"/></g></svg>
);
const UltrasonicIcon = (props) => <Icon component={UltrasonicSvg} {...props} />;

const { TabPane } = Tabs;
const DashboardTest = ({
  getSpecificTruck,
  getSensoryDataByDate,
  deleteSensoryData,
  getSpecificDay,
  truck: { truck, loading, sensorydata, gps_loading, durationPerLoc },
}) => {

  let params = useParams();

  const [vehicleId] = useState(params.vehicle_id);
  Geocode.setApiKey(GOOGLE_API_KEY);
  Geocode.setLanguage("en");
  Geocode.setRegion("ph");

  const history = useHistory();
  const handleBack = () => {
    history.goBack();
  };
  const [driverName, setDriverName] = useState('');
  const [driverEMAIL, setDriverEMAIL] = useState('');
  const fetchData = async () => {
    const config = {
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer 710|pM8X4jvYMLantzl8Hmx2oRhH8vy9OFCE2qfswibQ'
      },
    };
  
    try {
      const response = await axios.get(API_BACKEND + `/api/vehiclesIOT/${vehicleId}`, config);

      const driverFName = response.data.results.user.fname;
      const driverSName = response.data.results.user.lname;
      setDriverName(driverFName+" "+driverSName);

      const driverEmail = response.data.results.user.email;
      setDriverEMAIL(driverEmail);
    } catch (err) {
      console.error(err);
    }
  };
  
  // Move the DriverInfo component outside the function and use the useEffect hook
  useEffect(() => {
    fetchData();
  }, []);
  const [socket, setSocket] = useState(null);

  const [soundSensor, setSoundSensor] = useState([]);
  const [alcohol, setAlcohol] = useState([]);
  const [accelerationX, setAccelerationX] = useState([]);
  const [accelerationY, setAccelerationY] = useState([]);
  const [accelerationZ, setAccelerationZ] = useState([]);
  const [rotationX, setRotationX] = useState([]);
  const [rotationY, setRotationY] = useState([]);
  const [rotationZ, setRotationZ] = useState([]);
  const [gyroTemperature, setGyroTemperature] = useState([]);
  const [distance, setDistance] = useState([]);
  const [speed, setSpeed] = useState([0]);

  const [sensor, setSensorData] = useState([]);

  const [alcoholStyle, setAlcoholStyle] = useState("green");
  const [alcoholDesc, setAlcoholDesc] = useState("Sober");

  const [soundStyle, setSoundStyle] = useState("green");
  const [soundDesc, setSoundDesc] = useState("Clear");
  const [ultrasonicStyle, setUltrasonicStyle] = useState("green");
  const [ultrasonicDesc, setUltrasonicDesc] = useState("Normal");
  const [locationData, setLocationData] = useState([]);
  const [longLat, setLongLat] = useState({});
  const [gyroAcceleration, setGyroAcceleration] = useState([]);
  const [gyroRotation, setGyroRotation] = useState([]);
  const [gpsData, setGpsData] = useState([]);
  const [gpsCenter, setGpsCenter] = useState({
    lat: 14.62613552813322,
    lng: 121.06161758105758,
  });

  //Static History
  const [staticCenter, setStaticCenter] = useState({     lat: 14.62613552813322,
    lng: 121.06161758105758, });
  const [staticDurationData, setStaticDurationData] = useState([]);

  const handleEraseAll = () => {
    deleteSensoryData(vehicleId);
  };
  const fetchFilteredData = (filterDate) => {
    getSensoryDataByDate(vehicleId, filterDate);
  };

  const onDateChange = (value) => {
    fetchFilteredData(value.target.value);
  };

  const sensorDataFetch = (data) => {
    setSensorData((oldData) => [...oldData, data.data]);
  };

  const gpsSensorDataFetch = async (data) => {
    setLongLat(data.gps_data.GPS[0]);
    await Geocode.fromLatLng(
      data.gps_data.GPS[0].lat,
      data.gps_data.GPS[0].lng
    ).then(
      (response) => {
        const address = response.results[0].formatted_address;

        setLocationData(address);
      },
      (error) => {
        console.error(error);
      }
    );

    setGpsData((oldData) => oldData.concat(data.gps_data.GPS));
    data.gps_data.GPS.map((val) => {
      setGpsCenter({
        lat: val.lat,
        lng: val.lng,
      });
    });
  };

  const gyroSensorDataFetch = (data) => {
    setGyroAcceleration((oldData) =>
      oldData.concat(data.gyro_data.Acceleration)
    );
    setGyroRotation((oldData) => oldData.concat(data.gyro_data.Rotation));
  };

  const handleAlcoholSensorStyle = (data) => {
    if (data < 120) {
      setAlcoholStyle("green");
      setAlcoholDesc("Sober");
    } else if (data >= 120 && data < 400) {
      setAlcoholStyle("yellow");
      setAlcoholDesc("Drinking");
    } else {
      setAlcoholStyle("red");
      setAlcoholDesc("Drunk");
    }
  };

  const handleSoundSensorStyle = (data) => {
    if (data == 0) {
      setSoundStyle("green");
      setSoundDesc("Clear");
    } else {
      setSoundStyle("red");
      setSoundDesc("Detected");
    }
  };

  const handleUltrasonicStyle = (data) => {
    if (data >= 0 && data <= 150) {
      setUltrasonicStyle("red");
      setUltrasonicDesc("Too Close");
    } else {
      setUltrasonicStyle("green");
      setUltrasonicDesc("Good");
    }
  };
  const handleDateChange = (date, dateString) => {
    getSpecificDay(vehicleId, dateString);
    console.log(dateString);
  };

  const staticDateChange = (date, dateString) => {
    try {
      axios
        .get(API_URL + `/api/trucks/durationPerDay/${vehicleId}/${dateString}`)
        .catch(function (error) {
          console.log(error.toJSON());
        })
        .then((response) => {
          if (response !== undefined && response.data !== undefined) {
            if (response.data.length > 0) {
              console.log(response.data);
              setStaticCenter(response.data[0].position);
              setStaticDurationData(response.data);
              //console.log(response.data[0].position);
            } else {
              setStaticCenter({
                lat: 14.62613552813322,
                lng: 121.06161758105758,
              });
            }
        }});
      console.log(dateString);
    } catch (err) {
      if (err) {
        console.log("Input Error");
      }
    }
  };
  const openNotification = (socket_ID) => {
    const key = `open${Date.now()}`;
    notification.info({
      message: "Established Realtime Connection",
      description: `Socket id: ${socket_ID}`,
      key,
    });
  };

  useEffect(() => {
    getSpecificTruck(vehicleId);
    fetchFilteredData("1D");
  }, []);

  useEffect(() => {
    setSocket(
      io.connect(API_URL, {
        transports: ["websocket", "polling"],
      })
    );
  }, []);

  useEffect(() => {
    if (!socket) return;
    socket.on("connect", () => {
      openNotification(socket.id);
    });
    socket.on(`${vehicleId}`, (data) => {
      setSoundSensor(data.data.sound_sensor);
      setAlcohol(data.data.alcohol_sensor);
      setAccelerationX(data.data.gyro_sensor_acceleration_x);
      setAccelerationY(data.data.gyro_sensor_acceleration_y);
      setAccelerationZ(data.data.gyro_sensor_acceleration_z);
      setRotationX(data.data.gyro_sensor_rotation_x);
      setRotationY(data.data.gyro_sensor_rotation_y);
      setRotationZ(data.data.gyro_sensor_rotation_z);
      setDistance(data.data.ultrasonic_sensor);
      setSpeed(data.data.max_gps_speed);
      setGyroTemperature(data.data.gyro_sensor_temperature);
      handleAlcoholSensorStyle(data.data.alcohol_sensor);

      handleSoundSensorStyle(data.data.sound_sensor);
      handleUltrasonicStyle(data.data.ultrasonic_sensor);
      sensorDataFetch(data);
      gpsSensorDataFetch(data);
      gyroSensorDataFetch(data);
    });
    return () => socket.disconnect();
  }, [socket]);

  return loading && truck === null ? (
    <Spinner />
  ) : (
    <DocumentMeta {...meta}>
      <Fragment>
        <Tabs
          type="card"
          style={{ padding: "4px", fontFamily: "Inter, sans-serif" }}
        >
          <TabPane tab="Information and Location" key="1">
            <PageHeader
              className="site-page-header page-header"
              subTitle="Currently Monitored Information"
              tags={<Tag color="cyan">Overview</Tag>}
              style={{ marginBottom: "15px" }}
              // extra={[
              //   <Button
              //     type="primary"
              //     icon={<ArrowLeftOutlined />}
              //     onClick={handleBack}
              //   >
              //     Go Back
              //   </Button>,
              // ]}
            />
            <Row gutter={16}>
              <Col className="gutter-row" span={7}>

                <InfoCard
                  desc="Driver's Information"
                  info1="Driver's Name"
                  value1={driverName}
                  info2="Email"
                  value2={driverEMAIL}
                />

                <InfoCard
                  desc="Vehicle's Information"
                  info1="Vehicle Id"
                  value1={vehicleId}
                  info2="Vehicle Type"
                  value2={truck && truck.vehicle_type}
                  info3="Plate Number"
                  value3={truck && truck.plate_number}
                />

                <Row>
                  <Col span={24}>
                    <Link
                      to={{
                        pathname: `/monitor/${
                          truck && truck.vehicle_id
                        }/map-history`,
                        state: truck && truck.vehicle_id,
                      }}
                    >
                      <Button
                        type="primary"
                        block
                        size="middle"
                        className="button"
                      >
                        Location History
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </Col>
              <Col className="gutter-row" span={17}>
                <p style={{paddingLeft: 3, color: "gray" }}>Legend: &ensp; <img src={BusImg} style={{height: "18px", width: "13px"}}></img> Bus &emsp; <img src={JeepneyImg} style={{height: "18px", width: "13px"}}></img> Modern jeep</p>
                {locationData.length > 0 ? (
                  <>
                    <Alert
                      banner
                      type="info"
                      style={{ marginBottom: "15px", borderRadius: "6PX" }}
                      message={
                        <TextLoop mask>
                          <div>Current Vehicle's Location</div>
                          <div>{locationData}</div>
                          <div>
                            {longLat.lat} - {longLat.lng}
                          </div>
                        </TextLoop>
                      }
                    />
                  </>
                ) : (
                  <></>
                )}
                <GoogleMap
                  googleMapURL={
                    "https://maps.googleapis.com/maps/api/js?key=" +
                    GOOGLE_API_KEY +
                    "&libraries=geometry,drawing,places"
                  }
                  vTypes={truck && truck.vehicle_type}
                  loadingElement={<div style={{ height: `100%` }} />}
                  containerElement={<div style={{ height: `85vh` }} />}
                  mapElement={<div style={{ height: `100%` }} />}
                  truckPlateNum={truck && truck.plate_number}
                  defaultZoom={10}
                  zoom={20}
                  longitude={longLat.lng}
                  latitute={longLat.lat}
                  path={gpsData}
                  center={gpsCenter}
                  isMarkerShown
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tab="Realtime Cards" key="2">
            <PageHeader
              className="site-page-header page-header"
              subTitle="IoT Devices"
              tags={<Tag color="cyan">Realtime Cards</Tag>}
              // extra={[
              //   <Button
              //     type="primary"
              //     icon={<ArrowLeftOutlined />}
              //     onClick={handleBack}
              //   >
              //     Go Back
              //   </Button>,
              // ]}
            />
            <Row gutter={16} style={{ marginTop: "15px" }}>
              <Col span={6}>
                <Badge.Ribbon text={soundDesc} color={soundStyle}>
                  <SensorCard
                    content={
                      <div style={{ fontFamily: "Inter, sans-serif" }}>
                        <p style={{ fontWeight: "bold", marginBottom: "5px" }}>
                          Sound Sensor
                        </p>
                        <ul style={{ listStyle: "none" }}>
                          <li>
                            <Tag color="green">Clear</Tag> 0 bit
                          </li>
                          <li>
                            <Tag color="red">Detected</Tag> 1 bit
                          </li>
                        </ul>
                      </div>
                    }
                    title="Sound Sensor"
                    sectitle="Binary"
                    value={soundSensor}
                    suffix="bit"
                    icon={
                      <SoundIcon
                        style={{
                          fontSize: "38px",
                          marginLeft: "65px",
                          marginTop: "13px",
                          // color: '#a1f640',
                        }}
                      />
                    }
                  />
                </Badge.Ribbon>
                <Row style={{ marginTop: "16px" }}>
                  <Col span={24}>
                    <Badge.Ribbon text={ultrasonicDesc} color={ultrasonicStyle}>
                      <SensorCard
                        content={
                          <div style={{ fontFamily: "Inter, sans-serif" }}>
                            <p
                              style={{
                                fontWeight: "bold",
                                marginBottom: "5px",
                              }}
                            >
                              Ultrasonic Sensor
                            </p>
                            <ul style={{ listStyle: "none" }}>
                              <li>
                                <Tag color="red">To close</Tag> 0 - 150 cm
                              </li>
                              <li>
                                <Tag color="green">Good</Tag> 151 cm or greater{" "}
                              </li>
                            </ul>
                          </div>
                        }
                        title="Ultrasonic Sensor"
                        sectitle="Centimeter"
                        value={distance}
                        suffix="cm"
                        icon={
                          <UltrasonicIcon
                            style={{
                              fontSize: "35px",
                              paddingLeft: "65px",
                              paddingTop: "13px",
                              // color: '#BF3C90',
                            }}
                          />
                        }
                      />
                    </Badge.Ribbon>
                  </Col>
                </Row>
              </Col>
              <Col span={6}>
                <Badge.Ribbon text={alcoholDesc} color={alcoholStyle}>
                  <SensorCard
                    content={
                      <div style={{ fontFamily: "Inter, sans-serif" }}>
                        <p style={{ fontWeight: "bold", marginBottom: "5px" }}>
                          Alcohol Sensor
                        </p>
                        <ul style={{ listStyle: "none" }}>
                          <li>
                            <Tag color="green">Sober</Tag> 0 - 119 ppm
                          </li>
                          <li>
                            <Tag color="yellow">Drinking</Tag>120 - 399 ppm{" "}
                          </li>
                          <li>
                            <Tag color="red">Drunk</Tag> 400 ppm or greater
                          </li>
                        </ul>
                      </div>
                    }
                    title="Alcohol Sensor"
                    sectitle="Parts per million"
                    value={alcohol}
                    suffix="ppm"
                    icon={
                      <ExperimentOutlined
                        style={{
                          fontSize: "35px",
                          paddingLeft: "65px",
                          paddingTop: "13px",
                          // color: '#F97B6C',
                        }}
                      />
                    }
                  />
                </Badge.Ribbon>
                <Row style={{ marginTop: "16px" }}>
                  <Col span={24}>
                    <SensorCard
                      title="Gyroscope Sensor"
                      sectitle="Temperature"
                      value={gyroTemperature}
                      suffix="deg-C"
                      icon={
                        <ThermometerIcon
                          style={{
                            fontSize: "38px",
                            marginLeft: "65px",
                            marginTop: "13px",
                            // color: '#4F1BA8',
                            color: "#000",
                          }}
                        />
                      }
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Card
                  className="card"
                  cover={
                    <>
                      <h1
                        className="sensor-card-desc"
                        style={{ color: "#000" }}
                      >
                        Current Speed
                      </h1>
                      <Divider
                        style={{ marginTop: "5px", marginBottom: "5px" }}
                      />
                    </>
                  }
                >
                  <Speed gpsSpeed={speed} />
                </Card>
              </Col>
            </Row>
            <Col span={24}>
              <Row gutter={16} style={{ marginTop: "17px" }}>
                <Col span={12}>
                  <SensorCardForGyro
                    content={
                      <div style={{ fontFamily: "Inter, sans-serif" }}>
                        <p style={{ fontWeight: "bold", marginBottom: "5px" }}>
                          Accelerometer Sensor
                        </p>
                        <img
                          src={ACCELEROMETER}
                          alt="Accelerometer Legend"
                          width={330}
                          height={200}
                        />
                      </div>
                    }
                    title="Accelerometer Sensor"
                    sectitle1="Acceleration X"
                    sectitle2="Acceleration Y"
                    sectitle3="Acceleration Z"
                    value1={accelerationX}
                    value2={accelerationY}
                    value3={accelerationZ}
                    suffix="m/s2"
                    icon={
                      <RiseOutlined
                        style={{
                          fontSize: "35px",
                          paddingLeft: "65px",
                          paddingTop: "13px",
                          // color: '#4177DA',
                        }}
                      />
                    }
                  />
                </Col>

                <Col span={12}>
                  <SensorCardForGyro
                    content={
                      <div style={{ fontFamily: "Inter, sans-serif" }}>
                        <p style={{ fontWeight: "bold", marginBottom: "5px" }}>
                          Gyroscope Sensor
                        </p>

                        <img
                          src={GYROSCOPE}
                          alt="Gyroscope Legend"
                          width={330}
                          height={200}
                        />
                      </div>
                    }
                    title="Gyroscope Sensor"
                    sectitle1="Rotation X"
                    sectitle2="Rotation Y"
                    sectitle3="Rotation Z"
                    value1={rotationX}
                    value2={rotationY}
                    value3={rotationZ}
                    suffix="r/s"
                    icon={
                      <MdRotateRight
                        style={{
                          fontSize: "38px",
                          marginLeft: "65px",
                          marginTop: "13px",
                          // color: '#C97A27',
                        }}
                      />
                    }
                  />
                </Col>
              </Row>
            </Col>
            <SensorTable sensorData={sensor} vehicleId={vehicleId} />
          </TabPane>
          <TabPane tab="Realtime Graphs" key="3">
            <PageHeader
              className="site-page-header page-header"
              subTitle="IoT Devices"
              tags={<Tag color="cyan">Realtime Graphs</Tag>}
              // extra={[
              //   <Button
              //     type="primary"
              //     icon={<ArrowLeftOutlined />}
              //     onClick={handleBack}
              //   >
              //     Go Back
              //   </Button>,
              // ]}
            />
            <Col span={24}>
              <Row gutter={16}>
                <Col span={12} style={{marginBottom: "30px"}} >
                  <PageHeader
                    className="site-page-header sensor-page-header"
                    subTitle="Sound Sensor"
                    tags={<Tag color="green">binary</Tag>}
                  />
                  <SensorGraph yfield="sound_sensor" sensorData={sensor}/>
                </Col>
                <Col span={12}>
                  <PageHeader
                    className="site-page-header sensor-page-header"
                    subTitle="Alcohol Sensor"
                    tags={<Tag color="red">ppm</Tag>}
                  />
                  <SensorGraph yfield="alcohol_sensor" sensorData={sensor} />
                </Col>
                <Col span={12} style={{marginBottom: "30px"}}>
                  <PageHeader
                    className="site-page-header sensor-page-header"
                    subTitle="Accelerometer Sensor Acceleration"
                    tags={<Tag color="blue">m/s2</Tag>}
                  />
                  <SensorMultilineGraph data={gyroAcceleration} />
                </Col>
                <Col span={12}>
                  <PageHeader
                    className="site-page-header sensor-page-header"
                    subTitle="Gyroscope Sensor Rotation"
                    tags={<Tag color="orange">r/s</Tag>}
                  />
                  <SensorMultilineGraph data={gyroRotation} />
                </Col>
                <Col span={12}>
                  <PageHeader
                    className="site-page-header sensor-page-header"
                    subTitle="Gyroscope Sensor Temperature"
                    tags={<Tag color="purple">deg-C</Tag>}
                  />
                  <SensorGraph
                    yfield="gyro_sensor_temperature"
                    sensorData={sensor}
                  />
                </Col>
                <Col span={12}>
                  <PageHeader
                    className="site-page-header sensor-page-header"
                    subTitle="Ultrasonic Sensor"
                    tags={<Tag color="pink">cm</Tag>}
                  />
                  <SensorGraph
                    title="Ultrasonic Sensor (cm)"
                    yfield="ultrasonic_sensor"
                    sensorData={sensor}
                  />
                </Col>
              </Row>
            </Col>
          </TabPane>
          <TabPane tab="Static Duration History" key="4">
            <PageHeader
              className="site-page-header page-header"
              subTitle="History for driver's static duration per location"
              style={{ marginBottom: "15px" }}
              // extra={[
              //   <Button
              //     type="primary"
              //     icon={<ArrowLeftOutlined />}
              //     onClick={handleBack}
              //   >
              //     Go Back
              //   </Button>,
              // ]}
            />
            <Col span={24} >
              <Row gutter={16}>
                <Col className="gutter-row" span={7}>

                  <InfoCard
                      desc="Driver's Information"
                      info1="Driver's Name"
                      value1={driverName}
                      info2="Email"
                      value2={driverEMAIL}
                  />

                  <InfoCard
                    desc="Vehicle's Information"
                    info1="Vehicle Id"
                    value1={vehicleId}
                    info2="Vehicle Type"
                    value2={truck && truck.vehicle_type}
                    info3="Plate Number"
                    value3={truck && truck.plate_number}
                  />

                  <Row>
                    <Col span={24}>
                      <DatePicker
                        style={{
                          paddingTop: "5px",
                          marginTop: "18px",
                          paddingBottom: "3px",
                          marginBottom: "10px",
                          width: "410px",
                        }}
                        size="meidum"
                        onChange={staticDateChange}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col className="gutter-row" span={17}>
                  <p style={{paddingLeft: 3, color: "gray" }}>Legend: &ensp; <img src={BusImg} style={{height: "18px", width: "13px"}}></img> Bus &emsp; <img src={JeepneyImg} style={{height: "18px", width: "13px"}}></img> Modern jeep</p>
                  {locationData.length > 0 ? (
                    <>
                      <Alert
                        banner
                        type="info"
                        style={{ marginBottom: "15px", borderRadius: "6PX" }}
                        message={
                          <TextLoop mask>
                            <div>Current Vehicle's Location</div>
                            <div>{locationData}</div>
                            <div>
                              {longLat.lat} - {longLat.lng}
                            </div>
                          </TextLoop>
                        }
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  <GoogleMap
                    googleMapURL={
                      "https://maps.googleapis.com/maps/api/js?key=" +
                      GOOGLE_API_KEY +
                      "&libraries=geometry,drawing,places"
                    }
                    vTypes={truck && truck.vehicle_type}
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: `85vh` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    truckPlateNum={truck && truck.plate_number}
                    defaultZoom={10}
                    zoom={17}
                    longitude={longLat.lng}
                    latitute={longLat.lat}
                    center={staticCenter}
                    dataStatic={staticDurationData}
                    isMultipleMarker
                  />
                </Col>
              </Row>
            </Col>
          </TabPane>
          <TabPane tab="History" key="5">
            {/* <PageHeader
            className='site-page-header page-header'
            subTitle="Truck Driver's Performance Summary"
            tags={<Tag color='cyan'>Overall</Tag>}
          />

          <Row gutter={16} style={{ marginTop: '15px' }}>
            <Col lg={8} xl={6}>
              <SummaryCard
                title='Maximum Speed'
                value='3'
                prefix={<ArrowUpOutlined />}
                suffix='mph'
                description='-4.2% compared yesterday'
              />
            </Col>
            <Col lg={8} xl={6}>
              <SummaryCard
                title='Swerving Count'
                value='5'
                prefix={<ArrowUpOutlined />}
                suffix=''
                description='+0.7% compared yesterday'
              />
            </Col>
            <Col lg={8} xl={6}>
              <SummaryCard
                title='Sudden Stop'
                value='3'
                prefix={<ArrowDownOutlined />}
                suffix=''
                description='-0.3% compared yesterday'
              />
            </Col>
            <Col lg={8} xl={6}>
              <SummaryCard
                title='Delivery Count'
                value='2'
                prefix={<ArrowUpOutlined />}
                suffix=''
                description='+0.7% compared yesterday'
              />
            </Col>
          </Row> */}
            <PageHeader
              className="site-page-header page-header"
              subTitle="IoT Devices Summary"
              tags={<Tag color="cyan">Overall</Tag>}
              extra={
                <Popconfirm
                  title="All sensory data available on this vehicle will be deleted.
            Are you sure you want to do this?"
                  okText="Erase"
                  subTitle="asda"
                  cancelText="Cancel"
                >
                {/*  <Button*/}
                {/*  type="primary"*/}
                {/*  icon={<ArrowLeftOutlined />}*/}
                {/*  onClick={handleBack}*/}
                {/*  style={{marginRight: 10}}*/}
                {/*>*/}
                {/*  Go Back*/}
                {/*</Button>*/}
                  <Button type="danger" onClick={handleEraseAll}> 
                    Erase All
                  </Button>
                </Popconfirm>
              }
            />

            <Radio.Group
              onChange={onDateChange}
              defaultValue="1D"
              buttonStyle="solid"
              className="radio-group"
            >
              <Radio.Button value="1D" default>
                1D
              </Radio.Button>
              <Radio.Button value="7D">7D</Radio.Button>
              <Radio.Button value="1M">1M</Radio.Button>
              <Radio.Button value="3M">3M</Radio.Button>
              <Radio.Button value="1Y">1Y</Radio.Button>
              <Radio.Button value="ALL">ALL</Radio.Button>
            </Radio.Group>
            <DatePicker
              style={{
                marginLeft: ".5em",
                paddingTop: "5px",
                paddingBottom: "3px",
              }}
              size="medium"
              onChange={handleDateChange}
            />
            {gps_loading ? (
              <>
                <Spinner />
              </>
            ) : (
              <>
                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col span={12} style={{ marginBottom: "20px" }}>
                    <Fragment>
                      <PageHeader
                        className="site-page-header sensor-page-header"
                        subTitle="Sound Sensor"
                        tags={<Tag color="green">binary</Tag>}
                      />
                      <SensorGraphArea
                        yfield="sound_sensor"
                        sensorData={
                          sensorydata && sensorydata.data.sensory_data
                        }
                      />
                    </Fragment>
                  </Col>
                  <Col span={12} style={{ marginBottom: "0" }}>
                    <Fragment>
                      <PageHeader
                        className="site-page-header sensor-page-header"
                        subTitle="Alcohol Sensor"
                        tags={<Tag color="red">ppm</Tag>}
                      />
                      <SensorGraphArea
                        yfield="alcohol_sensor"
                        sensorData={
                          sensorydata && sensorydata.data.sensory_data
                        }
                      />
                    </Fragment>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginBottom: "0" }}>
                  <Col span={12} style={{ marginBottom: "20px" }}>
                    <Fragment>
                      <PageHeader
                        className="site-page-header  sensor-page-header"
                        subTitle="Gyroscope Sensor Acceleration"
                        tags={<Tag color="blue">m/s^2</Tag>}
                      />

                      <SensorMultilineGraphAreaHistory
                        data={sensorydata && sensorydata.acceleration}
                      />
                    </Fragment>
                  </Col>
                  <Col span={12} style={{ marginBottom: "0" }}>
                    <Fragment>
                      <PageHeader
                        className="site-page-header  sensor-page-header"
                        subTitle="Gyroscope Sensor Rotation"
                        tags={<Tag color="orange">radians/s</Tag>}
                      />

                      <SensorMultilineGraphAreaHistory
                        data={sensorydata && sensorydata.rotation}
                      />
                    </Fragment>
                  </Col>
                </Row>
                <Row gutter={16} style={{ marginBottom: "15px" }}>
                  <Col span={12}>
                    <Fragment>
                      <PageHeader
                        className="site-page-header  sensor-page-header"
                        subTitle="Gyroscope Sensor Temperature"
                        tags={<Tag color="purple">deg-C</Tag>}
                      />
                      <SensorGraphArea
                        yfield="gyro_sensor_temperature"
                        sensorData={
                          sensorydata && sensorydata.data.sensory_data
                        }
                      />
                    </Fragment>
                  </Col>
                  <Col span={12}>
                    <Fragment>
                      <PageHeader
                        className="site-page-header  sensor-page-header"
                        subTitle="Ultrasonic Sensor"
                        tags={<Tag color="pink">cm</Tag>}
                      />
                      <SensorGraphArea
                        yfield="ultrasonic_sensor"
                        sensorData={
                          sensorydata && sensorydata.data.sensory_data
                        }
                      />
                    </Fragment>
                  </Col>
                </Row>
                <SensorTableReview
                  style={{ marginTop: "14px" }}
                  sensorData={sensorydata && sensorydata.data.sensory_data}
                  assignedDriver={truck && truck.assigned_driver}
                  vehicleId={vehicleId}
                />
              </>
            )}
          </TabPane>
        </Tabs>
      </Fragment>
    </DocumentMeta>
  );
};

DashboardTest.propTypes = {
  getSpecificTruck: PropTypes.func.isRequired,
  getSensoryDataByDate: PropTypes.func.isRequired,
  getSpecificDay: PropTypes.func.isRequired,
  deleteSensoryData: PropTypes.func.isRequired,
  truck: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  truck: state.truck,
});
export default connect(mapStateToProps, {
  getSensoryDataByDate,
  getSpecificTruck,
  deleteSensoryData,
  getSpecificDay,
})(DashboardTest);